import { Redirect, Route, RouteComponentProps  } from "wouter";
import { selectAuthLoading, selectUser } from "@/features/auth/authSlice";
import { useAppSelector } from "@/hooks/use-state";
import { Loader2 } from "lucide-react";

interface ProtectedHomeRouteProps {
  component: React.ComponentType<RouteComponentProps>;
  path: string;
}

export function ProtectedAuthRoute({ component: Component, path }: ProtectedHomeRouteProps) {
  const user = useAppSelector(selectUser);
  const isLoading = useAppSelector(selectAuthLoading);
  
  if (isLoading) {
    return (
      <Route path={path}>
        <div className="flex items-center justify-center min-h-screen">
          <Loader2 className="h-8 w-8 animate-spin text-[var(--color-primary)]" />
        </div>
      </Route>
    );
  }

  if (!user) {
    return (
      <Route path={path}>
        <Redirect to="/auth" />
      </Route>
    );
  }
    
  return <Route path={path} component={Component} />;
}